import s from "./index434.js";
import { resolveComponent as l, createElementBlock as m, openBlock as t, createBlock as r, createCommentVNode as n, withCtx as a, createTextVNode as i, toDisplayString as c } from "vue";
import d from "./index231.js";
const p = ["data-component"];
function f(e, y, u, k, C, g) {
  const o = l("cs-secondary-button");
  return t(), m("div", {
    "data-component": e.$options.name,
    class: "flex items-center justify-end gap-16"
  }, [
    e.primaryAction ? (t(), r(o, {
      key: 0,
      href: e.primaryAction.url,
      target: e.primaryAction.target,
      isSmall: !0,
      onClick: e.onPrimaryClick
    }, {
      default: a(() => [
        i(c(e.primaryAction.text), 1)
      ]),
      _: 1
    }, 8, ["href", "target", "onClick"])) : n("", !0),
    e.secondaryAction ? (t(), r(o, {
      key: 1,
      href: e.secondaryAction.url,
      target: e.secondaryAction.target,
      isSmall: !0,
      onClick: e.onSecondaryClick
    }, {
      default: a(() => [
        i(c(e.secondaryAction.text), 1)
      ]),
      _: 1
    }, 8, ["href", "target", "onClick"])) : n("", !0)
  ], 8, p);
}
const $ = /* @__PURE__ */ d(s, [["render", f]]);
export {
  $ as default
};
